export enum UploadIdStatesEnumeration {
  DIFFERENT_DATA = 'DIFFERENT_DATA', // Verify data
  LANDING = 'LANDING', // Take a photo
  VERIFICATION = 'VERIFICATION', // Iframe
}
